import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    q: "How long does a full detail take?",
    a: "Our Premium full detail runs 5–6 hours, and the Ultimate can take 1–2 days depending on paint correction and ceramic cure time. We give every vehicle the time it genuinely needs.",
  },
  {
    q: "Do you come to me, or do I bring my car?",
    a: "All detailing is performed at your location — driveway, office, or garage. We bring water, power, and lighting on the rig. Service radius covers Sheboygan, Sheboygan Falls, Kohler, and Plymouth.",
  },
  {
    q: "How long does ceramic coating last?",
    a: "Our 2-year professional ceramic is standard with the Ultimate package; we also offer 5-year and 7-year options on request. All coatings require proper decontamination and paint correction first — that's why the prep matters as much as the product.",
  },
  {
    q: "Is paint correction safe on my car?",
    a: "Yes. We use dual-action polishers, thickness gauges, and test panels. We remove only as much clear coat as needed to cut defects — never aggressively.",
  },
  {
    q: "What forms of payment do you accept?",
    a: "Cash, all major credit cards, Apple Pay, and bank transfer. A 25% deposit secures your appointment slot.",
  },
  {
    q: "Do you offer gift cards?",
    a: "Absolutely — any dollar amount, redeemable against any service or package. Contact us to purchase.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-red-500" />
            <span className="text-xs tracking-[0.3em] uppercase text-red-500 font-bold">
              Frequently Asked
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tighter leading-[0.95]">
            Everything <br />
            <span className="text-zinc-600">you wanted</span> <br />
            to know.
          </h2>
          <p className="mt-8 text-zinc-400 text-base md:text-lg leading-relaxed max-w-md">
            Can't find your answer? Our team responds to emails within a few
            hours during business days.
          </p>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-zinc-900"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-display uppercase text-lg md:text-xl tracking-tight hover:text-red-500 hover:no-underline"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 text-base leading-relaxed pb-6 pr-8">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
